import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { UserRegDetails } from 'src/app/models/user';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { SnoozeIncidentDialogComponent } from '../snooze-incident-dialog/snooze-incident-dialog.component';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { ISelectedAttachments } from '../lodge-complaint-diaog/lodge-complaint-diaog.component';

@Component({
  selector: 'app-incident-details-dialog',
  templateUrl: './incident-details-dialog.component.html',
  styleUrls: ['./incident-details-dialog.component.scss'],
})
export class IncidentDetailsDialogComponent {
  @Input() set incidentDetails(val: IIncidents) {
    if (val) this.setIncidentDetails(val);
  }
  @Input() set isPopup(val: boolean) {
    if (!val) this.isPopDetails = val;
  }
  @Input() set orgUser(val: UserRegDetails[]) {
    this.usersList = val.filter(
      (x) => x.userRole == 'admin' || x.userRole == 'security'
    );

    this.filteredUserList = this.usersList;
    this.hostFilter.valueChanges.subscribe((value) => {
      this.filteredUserList = this.filterHosts(value);
    });
  }
  @Output() closeIncidentDetail = new EventEmitter<boolean>();
  @Output() snoozeIncident = new EventEmitter<any>();
  @Output() showTimeline = new EventEmitter<any>();
  @ViewChild('OnZoomDialog', { static: true }) onZoomDialog: TemplateRef<any>;
  @ViewChild('OnUpdateAssign', { static: true })
  onUpdateAssign: TemplateRef<any>;
  isPopDetails = true;
  hostFilter = new FormControl();
  evidence: any = null;
  selectedMultipleAttachment: ISelectedAttachments[] = [];
  selectedAttachments: File[] = [];
  complainEvidence: { FileName: string; FileType: string; Url: string }[] = [];
  complainDetail: ComplaintsTickets;
  orgId = localStorage.getItem('OrganizationId');
  incidentDetail: IIncidents;
  IdentityId = '';
  isIncidentDescription = false;
  isTimeline = false;
  isShowTime = false;
  isUpdateIncident = false;
  usersList: UserRegDetails[];
  filteredUserList: UserRegDetails[] = [];
  showIncidentDetailsForm = this.formbuilder.group({
    incidentId: [''],
    incidentName: [''],
    incidentType: [''],
    incidentLocation: [''],
    incidentDescription: [''],
    sourceAsset: [''],
    sourceAssetId: [''],
    incidentStatus: [''],
    incidentCriticality: [''],
    assignedTo: [''],
    assignedToUserId: [''],
    incidentReporter: [''],
    eventEvidence: [''],
    eventCreatedBy: [''],
    eventCreateDate: [''],
    eventClosedDate: [''],
    eventCreatedByUserID: [''],
    isManualEvent: [''],
    eventSnoozeDeadline: [''],
    eventOwnerName: [''],
    eventOwnerEmail: [''],
    eventOwnerPhone: [''],
    attachments: [],
  });
  screenSize: ScreenType;
  isShowReporter: boolean = false;
  isMultipleEvidence: boolean = false;

  constructor(
    private formbuilder: FormBuilder,
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IncidentDetailsDialogComponent>
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });

    this.setIncidentDetails(
      data.incident.complainIncidentDetails
        ? data.incident.complainIncidentDetails
        : data.incident
    );
    this.complainDetails(data.incident);
    this.usersList = data.users.filter(
      (x: any) => x.userRole == 'admin' || x.userRole == 'security'
    );
    this.filteredUserList = this.usersList;
    this.hostFilter.valueChanges.subscribe((value) => {
      this.filteredUserList = this.filterHosts(value);
    });
  }

  complainDetails(val: ComplaintsTickets) {
    if (val) {
      this.complainDetail = val;
      if (val.evidence) {
        this.isMultipleEvidence = true;
        this.complainEvidence = JSON.parse(val.evidence);
      }
      if (val.complainIncidentDetails?.multipleEvidence) {
        let complainmultipleEvidence = JSON.parse(
          val.complainIncidentDetails.multipleEvidence
        );
        complainmultipleEvidence.forEach((element: any) => {
          this.complainEvidence.push(element);
        });
        this.isMultipleEvidence = true;
      }
      if (!this.evidence && this.complainEvidence) {
        this.evidence = this.complainEvidence[0]?.Url;
      }
    }
  }
  setIncidentDetails(val: IIncidents) {
    this.evidence = null;
    this.isUpdateIncident = false;
    this.incidentDetail = val;
    this.showIncidentDetailsForm.reset();
    this.isIncidentDescription = false;
    if (val.anprDetectDateTime || val.faceDetectDateTime) {
      this.isTimeline = true;
    }
    if (val.incidentDescription) {
      this.isIncidentDescription = true;
    }
    this.showIncidentDetailsForm.controls.incidentDescription.setValue(
      val.incidentDescription
    );
    this.showIncidentDetailsForm.controls.incidentId.setValue(val.incidentId);
    this.showIncidentDetailsForm.controls.incidentName.setValue(
      val.incidentName
    );
    this.showIncidentDetailsForm.controls.incidentType.setValue(
      val.incidentType.toUpperCase()
    );
    try {
      this.showIncidentDetailsForm.controls.incidentLocation.setValue(
        val.incidentLocation ? JSON.parse(val.incidentLocation)[0]?.label : ''
      );
    } catch (e) {
      // If JSON.parse fails, log the error and set the value to an empty string
      console.warn('Error parsing incidentLocation:', e);
      this.showIncidentDetailsForm.controls.incidentLocation.setValue(
        val.incidentLocation
      );
    }
    this.showIncidentDetailsForm.controls.sourceAsset.setValue(val.sourceAsset);
    const statusMap: any = {
      0: 'Open',
      1: 'Close',
      2: 'Verified',
      3: 'Snoozed',
      4: 'In-Progress',
      5: 'On-Hold',
      6: 'Approved',
      7: 'Rejected',
    };
    const incidentStatus: any = val.incidentStatus;
    const status = statusMap.hasOwnProperty(incidentStatus)
      ? statusMap[incidentStatus]
      : 'Not Specified';
    this.showIncidentDetailsForm.controls.incidentStatus.setValue(status);
    this.evidence = val.eventEvidence;
    if (this.evidence == null || this.evidence.length == 0) {
      // this.evidence =
    }
    this.showIncidentDetailsForm.controls.incidentCriticality.setValue(
      val.incidentCriticality
    );
    this.showIncidentDetailsForm.controls.assignedToUserId.setValue(
      val.assignedToUserId
    );
    this.showIncidentDetailsForm.controls.assignedTo.setValue(val.assignedTo);
    this.showIncidentDetailsForm.controls.incidentReporter.setValue(
      val.eventCreatedBy
    );
    this.isShowReporter = val.incidentType.toUpperCase() != 'AUTOMATIC';
    this.isShowTime = false;
  }
  onShowTimeline() {
    this.isShowTime = !this.isShowTime;
    this.showTimeline.emit(this.isShowTime);
  }
  onClose() {
    this.closeIncidentDetail.emit();
  }
  onEdit() {
    this.isUpdateIncident = true;
    // this.showIncidentDetailsForm.controls.assignedTo.setValue(null);
  }
  onClicktoZoom() {
    this.dialog.open(this.onZoomDialog, {
      height: '600px',
      width: '960px',
    });
  }
  onSnoozeIncident(val: IIncidents) {
    const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      let data = {
        isSnooze: true,
        durationType: result.durationType,
        durationSize: result.durationSize,
        incidentId: val.incidentId,
        orgId: val.orgId,
        incidenType: val.incidentType,
        incidentName: val.incidentName,
        assignedBy: localStorage.getItem('FullName'),
        assignedById: localStorage.getItem('UserId'),
        createBy: val.eventCreatedBy,
        createById: val.eventCreatedByUserID,
        assignTo: val.assignedTo,
        assignedToUserId: val.assignedToUserId,
        evidence: val.eventEvidence,
      };
      if (result) {
        this.snoozeIncident.emit(data);
      }
    });
  }
  onChangeAssignee(val: any) {
    const tempuser: UserRegDetails = this.usersList.filter(
      (x) => x.userId == val
    )[0];
    this.showIncidentDetailsForm.controls.assignedTo.setValue(val);
    this.showIncidentDetailsForm.controls.assignedToUserId.setValue(
      tempuser.firstname + ' ' + tempuser.lastname
    );
    this.showIncidentDetailsForm.controls.eventOwnerEmail.setValue(
      tempuser.email
    );
  }
  isNewEvidence = false;
  onUpdate() {
    const incidentStatusControl: string =
      this.showIncidentDetailsForm.controls.incidentStatus.value;
    let status: number;
    if (incidentStatusControl == '0' || incidentStatusControl == 'Open') {
      status = 0;
    }
    if (incidentStatusControl == '1' || incidentStatusControl == 'Close') {
      status = 1;
    }
    if (incidentStatusControl == '2' || incidentStatusControl == 'Verified') {
      status = 2;
    }
    if (incidentStatusControl == '3' || incidentStatusControl == 'Snoozed') {
      status = 3;
    }
    if (
      incidentStatusControl == '4' ||
      incidentStatusControl == 'In-Progress'
    ) {
      status = 4;
    }
    if (incidentStatusControl == '4' || incidentStatusControl == 'On-Hold') {
      status = 4;
    }
    if (incidentStatusControl == '6' || incidentStatusControl == 'Approved') {
      status = 6;
    }
    if (incidentStatusControl == '7' || incidentStatusControl == 'Rejected') {
      status = 7;
    }
    this.dialog.open(this.onUpdateAssign),
      {
        disableClose: false,
      };
    if (status == 3) {
      this.onSnoozeIncident(this.incidentDetail);
    } else {
      let data = {
        isSnooze: false,
        isAssigned:
          this.showIncidentDetailsForm.controls.assignedToUserId.value !=
          this.incidentDetail.assignedToUserId,
        isStatusChanged: status != this.incidentDetail.incidentStatus,
        orgId: this.orgId,
        incidentId: this.showIncidentDetailsForm.controls.incidentId.value,
        assignedTo: this.showIncidentDetailsForm.controls.assignedTo.value,
        assignedToUserId:
          this.showIncidentDetailsForm.controls.assignedToUserId.value,
        incidentType: this.showIncidentDetailsForm.controls.incidentType.value,
        incidentName: this.showIncidentDetailsForm.controls.incidentName.value,
        assignedBy: localStorage.getItem('FullName'),
        assignedById: localStorage.getItem('UserId'),
        incidentStatus: status,
        incidentLocation:
          this.showIncidentDetailsForm.controls.incidentLocation.value,
        incidentDescription:
          this.showIncidentDetailsForm.controls.incidentDescription.value,
        eventEvidence: this.evidence,
        multipleEventEvidence: this.selectedMultipleAttachment,
        eventOwnerEmail:
          this.showIncidentDetailsForm.controls.eventOwnerEmail.value,
        eventOwnerName:
          this.showIncidentDetailsForm.controls.eventOwnerName.value,
        eventOwnerPhone:
          this.showIncidentDetailsForm.controls.eventOwnerPhone.value,
        isNewEvidence: this.selectedMultipleAttachment?.length > 0,
      };
      this.snoozeIncident.emit(data);
      this.onClose();
    }
  }
  // onUpdate() {
  //   this.dialog.open(this.onUpdateAssign),
  //     {
  //       disableClose: false,
  //     };
  //   let data = {
  //     isSnooze: false,
  //     isAssigned:
  //       this.showIncidentDetailsForm.controls.assignedToUserId.value !=
  //       this.incidentDetail.assignedToUserId,
  //     isStatusChanged:
  //       parseInt(this.showIncidentDetailsForm.controls.incidentStatus.value) !=
  //       this.incidentDetail.incidentStatus,
  //     incidentId: this.showIncidentDetailsForm.controls.incidentId.value,
  //     assignedTo: this.showIncidentDetailsForm.controls.assignedTo.value,
  //     assignedToUserId:
  //       this.showIncidentDetailsForm.controls.assignedToUserId.value,
  //     incidentType: this.showIncidentDetailsForm.controls.incidentType.value,
  //     incidentName: this.showIncidentDetailsForm.controls.incidentName.value,
  //     assignedBy: localStorage.getItem('FullName'),
  //     assignedById: localStorage.getItem('UserId'),
  //     incidentLocation:
  //       this.showIncidentDetailsForm.controls.incidentLocation.value,
  //     incidentDescription:
  //       this.showIncidentDetailsForm.controls.incidentDescription.value,
  //     eventEvidence: this.evidence,
  //     eventOwnerEmail:
  //       this.showIncidentDetailsForm.controls.eventOwnerEmail.value,
  //   };
  //   this.snoozeIncident.emit(data);
  //   this.dialogRef.close();
  // }
  hostSelect(val: MatAutocompleteSelectedEvent) {
    this.usersList.forEach((item) => {
      if (item.firstname + ' ' + item.lastname === val.option.value) {
        this.showIncidentDetailsForm.controls.assignedToUserId.setValue(
          item.userId
        );
        this.showIncidentDetailsForm.controls.eventOwnerEmail.setValue(
          item.email
        );
        this.showIncidentDetailsForm.controls.assignedTo.setValue(
          item.firstname + ' ' + item.lastname
        );
      }
    });
    this.showIncidentDetailsForm.controls.assignedToUserId.markAsDirty();
  }
  filterHosts(value: string) {
    const filterValue = value.toLowerCase();
    return this.usersList.filter((host) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  onFileSelected(event: any) {
    const attachedContents: string[] = []; // Array to store file contents (optional)
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      this.selectedAttachments.push(files[i]);
      const file = files[i];
      const reader = new FileReader();

      reader.onload = (e) => {
        const contents = e.target.result as string;
        attachedContents.push(contents); // Add content to the array (optional)
        this.selectedMultipleAttachment.push({
          selectedAttachment: file,
          attachedContent: contents,
          attachedContentName: file.name,
          attachedContentType: file.type,
        });
      };
      reader.readAsDataURL(file);
    }

    // if (event.target.files[0]) {
    //   var reader = new FileReader();
    //   reader.readAsDataURL(event.target.files[0]);
    //   reader.onload = (event: any) => {
    //     this.evidence = event.target.result;
    //   };
    // }
  }
  isPdf = false;
  onShowEvidence(val: any, newFile: boolean = false) {
    if (
      val.FileType?.includes('image') ||
      val.attachedContentType?.includes('image')
    ) {
      this.evidence = newFile ? val.attachedContent : val.Url;
      this.isPdf = false;
    } else {
      this.evidence = newFile ? val.attachedContent : val.Url;
      this.isPdf = true;
    }
  }
  async onDownload(val: any) {
    try {
      const response = await fetch(val.Url);
      if (response.ok) {
        const blob = await response.blob();
        const extension = blob.type.split('/')[1];

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${val.FileName}`;
        link.click();
        URL.revokeObjectURL(link.href);
        console.log(blob, response);
      }
    } catch (error) {
      console.error(error);
    }
  }
  pdfLoaded = false;
  onPdfLoad() {
    this.pdfLoaded = true;
  }
  ScreenType = ScreenType;
}
